export const ViewIds = {
  USER_INVITES: '6914628a-bbad-4a51-872b-ab603958661a'
}